module.exports = __webpack_public_path__ + "img/hair_story.fdbfbe7d.jpg";